import React, { Component } from 'react';
const fb = process.env.PUBLIC_URL + '/img/facebook.svg';
const youtube = process.env.PUBLIC_URL + '/img/youtube.svg';
const whatsapp = process.env.PUBLIC_URL + '/img/whatsapp.svg';
const instagram = process.env.PUBLIC_URL + '/img/instagram.svg';

export default () => {
    return (

        <div className="redes-socias">
            <ul className="lista">
                <li><a href="tel:+5518998058975" ><img src={whatsapp} /> </a></li>
                <li><a href="https://www.instagram.com/escolhatecnologia/" target="_blank"><img src={instagram} /> </a></li>
                <li><a href="https://www.facebook.com/escolhatecnologia" target="_blank"><img src={fb} /> </a></li>
                <li><a href="https://www.youtube.com/channel/UCr632Bp9WjTKhkhzCioT1Pw" target="_blank"><img src={youtube} /> </a></li>
            </ul>
        </div>

    );
}
